import DialogComponent from '@Components/Common/DialogComponent';
import NumberFormatComp from '@Components/Common/NumberFormatComp';
import { DialogSectionCss } from '@PagesComponent/ActiveSmartShip/ActiveStyleComp';
import React, { useEffect, useState } from 'react';

const KitThankyouPage = ({ thankyouProps }) => {
    const [openForm, setOpenForm] = useState(false)

    return (
        <div className="thnku-sec kit_thankyoupage">
            <div className="container">
                {/* <div className='mian-thank'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                </svg>

                    <h2>Thank You </h2>
                    </div> */}
                <div className="thnkyou-page">
                    <h3>Your Order has been placed successfully</h3>
                    <h3>Your order ID is {thankyouProps?.publicOrderId && thankyouProps?.publicOrderId}</h3>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="thn-lft">
                            <h4>Billing Address
                            </h4>
                            <div className="row">
                                <div className='col-md-12'>
                                    <h3> First Name</h3>
                                    <div> {thankyouProps?.orderedData?.billing_address?.first_name}</div>
                                </div>
                                <div className='col-md-12'>
                                    <h3> Last Name</h3>
                                    <div>
                                        {thankyouProps?.orderedData?.billing_address?.last_name}
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <h3> Address 1</h3>
                                    <div>
                                        {thankyouProps?.orderedData?.billing_address?.street_address_1}
                                    </div>
                                </div>
                                {thankyouProps?.orderedData?.billing_address?.street_address_2 &&
                                    <div className='col-md-12'>
                                        <h3>Address 2</h3>
                                        <div>
                                            {thankyouProps?.orderedData?.billing_address?.street_address_2}
                                        </div>
                                    </div>}
                                {thankyouProps?.orderedData?.billing_address?.company_name &&
                                    <div className='col-md-12'>
                                        <h3>Company Name</h3>
                                        <div>
                                            {thankyouProps?.orderedData?.billing_address?.company_name}
                                        </div>
                                    </div>}
                                <div className='col-md-12'>
                                    <h3> City</h3>
                                    <div>{thankyouProps?.orderedData?.billing_address?.city}</div>
                                </div>
                                <div className='col-md-12'>
                                    <h3> State</h3>
                                    <div>{thankyouProps?.orderedData?.billing_address?.state}</div>
                                </div>
                                <div className='col-md-12'>
                                    <h3> Zip Code</h3>
                                    <div>{thankyouProps?.orderedData?.billing_address?.postal_code} </div>
                                </div>

                                <div className='col-md-12'>
                                    <h3> Country</h3>
                                    <div>{thankyouProps?.orderedData?.billing_address?.country} </div>
                                </div>

                                <div className='col-md-12'>
                                    <h3> Phone</h3>
                                    <div>{thankyouProps?.orderedData?.billing_address?.phone_number} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(thankyouProps?.orderedData?.order_details?.length > 0) &&
                    <div className="Cart_product">
                        <h4 className="tittle">Order details</h4>
                        <>
                            <div className='table-wrap'>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>product Image</th>
                                            <th>product name</th>
                                            <th>Quantity</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {thankyouProps?.orderedData?.order_details?.map((datas, index) => {
                                            return (
                                                <tr className="productDetailTable" key={index + 1}>
                                                    <td data-value="Product Image">
                                                        <div className="cart-product-details">
                                                            <img src={`${process.env.API_URL}${datas.product?.product_images[0]?.image}`} height='100' widt='100' />
                                                        </div>
                                                    </td>
                                                    <td data-value="Product name">
                                                        <div className="cart-product-name">
                                                            {datas.product.name}
                                                        </div>
                                                    </td>
                                                    <td data-value="Quantity">
                                                        <div className="cart-product-qty">
                                                            {datas.product_quantity}
                                                        </div>
                                                    </td>
                                                    <td data-value="Price"><div className="cart-product-price">
                                                        <NumberFormatComp value={+datas?.price_per_unit * +datas.product_quantity} />
                                                    </div></td>
                                                </tr>
                                            )
                                        })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </>
                        <div className="row">
                            <div className="col-md-8">
                            </div>
                            <div className="col-md-4">
                                <span className="Total"><strong>Total:</strong>
                                    <NumberFormatComp value={thankyouProps?.orderedData?.amount} />
                                </span>
                                {thankyouProps?.shippingAmount &&
                                    <span className="Total"><strong>Shipping Amount:</strong>
                                        <NumberFormatComp value={+thankyouProps?.shippingAmount} />
                                    </span>
                                }
                                {thankyouProps?.orderedData?.tax_amount &&
                                    <span className="Total"><strong>Tax Amount:</strong>
                                        <NumberFormatComp value={thankyouProps?.orderedData?.tax_amount} />
                                    </span>
                                }
                                {thankyouProps?.orderedData?.discount_amount > 0 &&
                                    <span className="Total"><strong>Discount:</strong>
                                        -<NumberFormatComp value={thankyouProps?.orderedData?.discount_amount} />
                                    </span>
                                }
                                <span className="amount_paid"><strong>Paid amount:</strong>
                                    <NumberFormatComp value={(thankyouProps?.orderedData?.amount_paid)} />
                                </span>
                            </div>
                        </div>
                    </div>
                }
                {/* <div className='buttonAction' style={{
                    width: " 100%",
                    textAlign: "center"
                }}>
                    <button onClick={() => setOpenForm(true)}>Go To Consent Form</button>

                </div> */}
            </div>

            <DialogComponent opend={openForm} handleClose={() => setOpenForm(false)} title="" classFor="consent_form"  >
                <DialogSectionCss>
                    <h3 className='consent-form'>You are almost done</h3> <br />
                    <p className='consent-para'>Please click here to consent your kit</p>

                    <button className='btn-primary-btn-consent' onClick={() => thankyouProps?.goToConsent()}>CONSENT YOUR KIT</button>
                </DialogSectionCss>
            </DialogComponent>
        </div >
    )
}

export default KitThankyouPage;